import ContentCard from '@/features/ContentList/shared/ContentCard';
import { MuiAvatar, MuiTypography } from '@/features/shared/material-ui';
import { CaptureClicksRichText } from '@/features/shared/RichText';
import clsx from 'clsx';
import { isEmpty } from 'lodash/fp';
import React from 'react';
import { TabbedCardTabPanelProps } from './TabbedCard.interfaces';
import { useTabbedCardTabPanelLogic } from './TabbedCardTabPanel.logic';
import { useTabbedCardTabPanelStyles } from './TabbedCardTabPanel.styles';

export const TabbedCardTabPanel = ({ tab, theme }: TabbedCardTabPanelProps) => {
  const classes = useTabbedCardTabPanelStyles({ columns: 3, gap: '24px' });

  const { cardColor, cardSections, cards, hasFeatured, parseCardSection } =
    useTabbedCardTabPanelLogic({ tab, theme });

  const renderCards = (cardContent: CardType, index: number) =>
    isEmpty(cardContent) ? (
      <div />
    ) : (
      <ContentCard
        className={clsx(classes.tabbedCard, 'tabbed-card')}
        data={{
          ...cardContent,
          cardLogo: undefined,
        }}
        theme={theme}
        cardColor={cardColor}
        key={index}
        renderCardHeading={
          <div className={classes.contentHeadingWrapper}>
            {cardContent?.cardLogo?.original?.url && (
              <MuiAvatar variant="square" src={cardContent?.cardLogo?.original?.url} />
            )}
            <MuiTypography
              className={clsx(classes.contentHeading, 'tabbed-card-heading')}
              variant="h6"
              dangerouslySetInnerHTML={{ __html: cardContent?.cardHeading || '' }}
            />
          </div>
        }
        renderCardDescription={
          <CaptureClicksRichText
            theme={theme}
            className={classes.contentDescription}
            content={cardContent?.cardDescription || ''}
          />
        }
      />
    );

  // render normal 3 cols template
  if (!hasFeatured) {
    return (
      <div className={classes.root}>
        <div className="card-row">{cards.map(renderCards)}</div>
      </div>
    );
  }

  // render section template
  return (
    <div className={classes.root}>
      {cardSections.map((cardSection: any[]) =>
        parseCardSection(cardSection).map((cardRow, index) => (
          <div key={`cardSection_${index}`} className={clsx('card-row', 'card-row-featured')}>
            {cardRow.map(renderCards)}
          </div>
        )),
      )}
    </div>
  );
};
